// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c2b0f33c","279":"0dfe0993","863":"76dc51a2","898":"7839b5d7"}[chunkId] + ".chunk.js";
};